"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Card", {
    enumerable: true,
    get: function() {
        return Card;
    }
});
var Card = {
    baseStyle: {
        borderRadius: "radii-card",
        padding: "1.25rem"
    }
};
